import { render, staticRenderFns } from "./DownloadQuestionnaireQuestionType.vue?vue&type=template&id=b629ee78&scoped=true"
import script from "./DownloadQuestionnaireQuestionType.vue?vue&type=script&lang=js"
export * from "./DownloadQuestionnaireQuestionType.vue?vue&type=script&lang=js"
import style0 from "./DownloadQuestionnaireQuestionType.vue?vue&type=style&index=0&id=b629ee78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b629ee78",
  null
  
)

export default component.exports